import { ActionCreatorWithoutPayload, createAction} from "@reduxjs/toolkit";

export namespace MainCurrentUserAction {

  export const userInfo: ActionCreatorWithoutPayload = createAction('GET_USER_INFO');
}
